export const BOOTSTRAP_TOKEN_PARAM = 'bootstrapToken'

let bootstrapToken: string | null = null
let bootstrapTokenTaken = false

/**
 * Called first in `index.tsx`, before any SDK can record the address (the early Sentry client sends the page URL
 * unscrubbed, Mixpanel sends `$current_url` with every event): the token is still exchangeable for a broker session
 * until the exchange runs, much later.
 */
export const captureBootstrapToken = (): void => {
  const url = new URL(window.location.href)
  const token = url.searchParams.get(BOOTSTRAP_TOKEN_PARAM)
  if (!token) return
  bootstrapToken = token
  url.searchParams.delete(BOOTSTRAP_TOKEN_PARAM)
  window.history.replaceState(window.history.state, '', url.toString())
}

export const takeBootstrapToken = (): string | null => {
  const token = bootstrapToken
  bootstrapToken = null
  if (token) bootstrapTokenTaken = true
  return token
}

export const wasBootstrapTokenTaken = (): boolean => bootstrapTokenTaken

export const _resetBootstrapTokenForTests = (): void => {
  bootstrapToken = null
  bootstrapTokenTaken = false
}
